export default __webpack_public_path__ + "static/media/MobileApp-800X500.dd9207a4.png";